<section class="section-announcements-dialog">
  <div class="modal-header">
    <input ngbAutofocus class="no-size" />
    <grid-ui-icon
      type="button"
      class="close-icon"
      aria-label="Cancel"
      data-hook="announcement-detail-modal-cancel"
      (click)="dismiss()"
      id="announcement-detail-modal-close-btn"
      ngbTooltip="Close window"
      name="cross-black"
      data-testid="icon-close-modal"
    >
    </grid-ui-icon>
  </div>

  @for (announcement of announcements; track announcement; let i = $index) {
    <div class="announcement-notification">
      @if (i === currentAnnouncementIndex) {
        <div class="modal-body">
          @if (announcement.type === 'GLOBAL') {
            <svg class="announcement-image">
              <use xlink:href="#global-announcement" />
            </svg>
          }
          @if (announcement.type === 'MODULE') {
            <svg class="announcement-image">
              <use xlink:href="#module-announcement" />
            </svg>
          }
          <h3 class="modal-body-title" data-hook="announcement-detail-modal-body-title">{{ announcement.title }}</h3>
          @if (announcement.text !== null) {
            <div class="modal-body-text" [innerHtml]="announcement.text! | safeHtml" data-hook="announcement-detail-modal-body-text"></div>
          }
          <div>
            <div class="modal-footer-block">
              <label>
                <input
                  type="checkbox"
                  [(ngModel)]="announcement.isDismissed"
                  (click)="toggle(announcement)"
                  data-testid="checkbox-dont-show"
                />
                <span> Don't show me this again </span>
              </label>
            </div>
            <div class="modal-footer-block">
              <button
                class="btn mc-btn-primary"
                (click)="dismiss()"
                id="announcement-detail-modal-accept-and-close-btn"
                data-testid="btn-accept"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div>
    @if (hasPreviousAnnouncement()) {
      <button (click)="previousAnnouncement()" class="previous-announcement" data-testid="btn-prev">
        <grid-ui-icon class="chevron-left-icon" name="left-arrow-caraousel"></grid-ui-icon>
      </button>
    }
  </div>
  <div>
    @if (hasNextAnnouncement()) {
      <button (click)="nextAnnouncement()" class="next-announcement" data-testid="btn-next">
        <grid-ui-icon class="chevron-right-icon" name="right-arrow-caraousel"></grid-ui-icon>
      </button>
    }
  </div>

  <div class="dot-indicators">
    @for (announcement of announcements; track announcement; let i = $index) {
      <span (click)="currentAnnouncementIndex = i" [class.active]="i === currentAnnouncementIndex" class="dot"></span>
    }
  </div>
</section>
